"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var emissionsStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        container: {
            '& h6': {
                fontFamily: typography.fontFamily,
            },
        },
    });
}, { name: 'GqlSummary_Emissions' });
exports.default = emissionsStyles;
